import { SUPPORTER_STATUSES_WITH_IDS } from '@/constants/filterCriteria/supporterStatus';
import { Supporter } from '@/types';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { GridColDef } from '@mui/x-data-grid';

/** Display / filter label for Rocket status (must match filter valueOptions). */
export function normalizeRocketStatusLabel(contactStatus: string): string {
  if (contactStatus === 'Complete' || contactStatus === 'Up to date') {
    return 'Up to date';
  }
  if (['Needs a call', 'Undefined', 'Needs contacting'].includes(contactStatus)) {
    return 'Needs contacting';
  }
  return contactStatus;
}

const rocketStatusValueOptions = [
  ...new Set(
    SUPPORTER_STATUSES_WITH_IDS.map((status) => normalizeRocketStatusLabel(status.label))
  ),
];

export const rocketColumn: (flex: number) => GridColDef<Supporter, string, unknown> = (
  flex: number
) => ({
  headerName: 'Rocket status',
  field: 'contactStatus',
  align: 'left',
  flex,
  type: 'singleSelect',
  valueOptions: rocketStatusValueOptions,
  editable: false,
  valueGetter: (value, row) => normalizeRocketStatusLabel(row.contactStatus),
  sortComparator: (v1, v2, param1, param2) => {
    const cmp = String(v1 ?? '').localeCompare(String(v2 ?? ''));
    if (cmp !== 0) {
      return cmp;
    }
    return Number(param1.id) - Number(param2.id);
  },
  renderCell: (params) => {
    const label = normalizeRocketStatusLabel(params.row.contactStatus);
    if (label === 'Up to date') {
      return (
        <>
          <CheckCircleOutlineIcon sx={{ color: 'green', fontSize: 'inherit' }} /> Up to date
        </>
      );
    }
    if (label === 'Needs contacting') {
      return (
        <>
          <WarningAmberIcon sx={{ color: 'red', fontSize: 'inherit' }} /> Needs contacting
        </>
      );
    }
    return <>{label}</>;
  },
});
